"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLabeledField = exports.isLabeledWidget = exports.isHasValueWidget = exports.setEnabled = exports.isEnabled = exports.setElementVisible = exports.isElementVisible = void 0;
const __1 = require("..");
function isElementVisible(element) {
    return __1.DOM.isVisibleInDOM(element);
}
exports.isElementVisible = isElementVisible;
function setElementVisible(element, visible, retainPlacement = false) {
    if (!element) {
        return;
    }
    if (visible) {
        element.style.display = "";
        element.style.visibility = "";
        element.removeAttribute(__1.ARIA.HIDDEN);
    }
    else {
        element.style.display = retainPlacement ? "" : "none";
        element.style.visibility = "hidden";
        element.setAttribute(__1.ARIA.HIDDEN, "true");
    }
}
exports.setElementVisible = setElementVisible;
function isEnabled(element) {
    return !element.hasAttribute("disabled")
        && !element.hasAttribute(__1.ARIA.DISABLED);
}
exports.isEnabled = isEnabled;
function setEnabled(element, enabled) {
    element.toggleAttribute("disabled", !enabled);
    element.removeAttribute(__1.ARIA.DISABLED);
    if (!enabled) {
        element.setAttribute(__1.ARIA.DISABLED, "true");
    }
}
exports.setEnabled = setEnabled;
function isHasValueWidget(widget) {
    const hasValueWidget = widget;
    if (hasValueWidget.addValueChangeHandler === undefined) {
        return false;
    }
    if (hasValueWidget.getValue === undefined) {
        return false;
    }
    return hasValueWidget.setValue !== undefined;
}
exports.isHasValueWidget = isHasValueWidget;
function isLabeledWidget(widget) {
    const labeledWidget = widget;
    if (labeledWidget.getLabel === undefined) {
        return false;
    }
    return labeledWidget.getLabelElement !== undefined;
}
exports.isLabeledWidget = isLabeledWidget;
function isLabeledField(widget) {
    const labeledField = widget;
    if (!isHasValueWidget(labeledField)) {
        return false;
    }
    if (!isLabeledWidget(labeledField)) {
        return false;
    }
    return labeledField.getFieldElement !== undefined;
}
exports.isLabeledField = isLabeledField;
//# sourceMappingURL=WidgetUtil.js.map